// extracted by mini-css-extract-plugin
export var borderRadius = "_e2-4";
export var large = "_e2-3";
export var logoContainer = "_e2-0";
export var nameLogo = "_e2-2";
export var small = "_e2-1";